<div class="banner">
  <p class="banner-text">
    {{ 'cookies.disclaimer' | translate }}
  </p>
  <div class="banner-buttons">
    <button tuiButton (click)="accept.emit()" size="m">
      {{ 'cookies.accept' | translate }}
    </button>
    <a
      [href]="assetMap.docs?.dataProtectionPolicy"
      target="_blank"
      *ngIf="assetMap?.docs?.dataProtectionPolicy; else internalDataProtectionLink"
    >
      <button tuiButton appearance="outline" size="m">
        {{ 'cookies.dataProtectionPolicy' | translate }}
      </button>
    </a>
    <ng-template #internalDataProtectionLink>
      <button
        tuiButton
        appearance="outline"
        [routerLink]="['/', RouteNames.dataProtectionPolicy]"
        size="m"
      >
        {{ 'cookies.dataProtectionPolicy' | translate }}
      </button>
    </ng-template>
  </div>
</div>
